export enum entityType {
    interaction = 'interaction',
    workflow = 'workflow'
}

export enum entityPickType {
    justActive = 'JustActive',
    all = 'All'
}
